import cz from '../csCZ/dashlets';

const de: typeof cz = {
	search: {
		title: 'Suche',
		text:
			'Ermöglicht die Suche nach zusätzlichen Operationen und Indizes nach ausgewählten Kriterien.',
	},
	help: {
		title: 'Hilfe',
		text:
			'Häufig gestellte Fragen zur Suche und zu den Funktionen des digitalen Archivs.',
	},
	contact: {
		title: 'Kontakt',
		text:
			'Kontaktinformationen für das Brünner Stadtarchiv und ein Formular für Fragen von Forschern.',
	},
};

export default de;
